export namespace AppEnums {
  export const NOT_SELECTED: number = 0;

  export enum DrawerIds {
    NotSpecified = 'NotSpecified',
    SelectColumns = 'SelectColumns',
    SelectProfilePermissions = 'SelectProfilePermissions',
    Settings = 'Settings',
    SelectDeleteResult = 'SelectDeleteResult',
    ChatCitations = 'ChatCitations',
  }

  export enum IndexStatus {
    Pending = 0,
    Complete = 1,
    InProgress = 2,
    Error = 3,
    ToIndexed = 4,
  }

  export enum TagFilterNames {
    Status = 'Status',
    Months = 'Months',
    ShortNameTypes = 'ShortNameTypes',
    WeekDayNames = 'WeekDayNames',
  }

  export enum PracticeType {
    Type1 = 1,
    Type2 = 2,
  }

  export enum WorkflowStateActivityType {
    None = 0,
    UploadDocument = 1,
    GenerateDocument = 2,
    FormFilling = 3,
  }

  export enum BpmnElementTypes {
    Task = 'bpmn:Task',
    StartEvent = 'bpmn:StartEvent',
    EndEvent = 'bpmn:EndEvent',
    Event = 'bpmn:SequenceFlow',
    Label = 'label',
  }

  export enum AvatarTypes {
    Absent = 0,
    File = 2,
    Gravatar = 3,
  }

  export enum VerticalStepperItemType {
    PastState = 1,
    CurrentState = 2,
    FutureState = 3,
  }

  export enum ProductStatus {
    Todo = 0,
    Wip = 1,
    Done = 2,
  }

  export enum CanvasElementTypes {
    Text = 'Text',
    Table = 'Table',
    Checkbox = 'Checkbox',
    HandWrittenText = 'HandWrittenText',
  }

  export enum AvatarSource {
    Initials = 0,
    NoPicture = 1,
    ProfileImg = 2,
  }

  export enum PracticeRegenerateTagsOptions {
    All = 0,
    AllExceptManuallyChanged = 1,
  }

  export enum PracticeRegenerateInfoStatus {
    NotSet = 0,
    EmptyTagsSuccessfullySaved = 1,
    NoDossierFiles = 2,
    NoTags = 3,
    SuccessfullyStartedInBackground = 4,
  }

  export enum WebSocketMessageTypes {
    NotSet = 0,
    PracticeDocumentStatusUpdated = 1,
    RegenerateTagsStarted = 2,
    RegenerateTagsCompleted = 3,
    RegenerateTagsFailed = 4,
    GenerateDocumentFailed = 5,
    GenerateDocumentCompleted = 6,
    GenerateDocumentStarted = 7,
    GeneratedDocumentBeforeUploadAndIndexCompleted = 8,
  }

  export enum GenerateDocumentInfoStatus {
    NotSet = 0,
    NoTags = 1,
    EmptyTemplate = 2,
    SuccessfullyStartedInBackground = 3,
    SuccessfullyCompletedInBackground = 4,
    Failed = 5,
  }

  export enum DocumentPanelTabs {
    Text = 1,
    HandWritten = 2,
    SelectionMarks = 3,
    Table = 4,
  }

  export enum NotificationBackgroundServiceStatus {
    Started = 1,
    Completed = 2,
    Failed = 3,
  }

  export enum ActiveStatus {
    Active = 1,
    Inactive = 2,
  }

  export enum Routing {
    SkillBased = 1,
    Priority = 2,
  }

  export enum CheckboxStates {
    Selected = 'selected',
    Unselected = 'unselected',
  }

  export enum ExtractionStatus {
    NONE = 0,
    NOT_PERFORMED = 1,
    COMPLETED = 2,
  }

  export enum DocumentFilters {
    allUsers = 'ALL',
    onlyIndividual = 'INDIVIDUAL_ONLY',
  }

  export enum ProductDocumentAnalysisViewMode {
    paginated = 'Paginated',
    text = 'Text',
    structure = 'Structure',
  }

  export enum ProductActivities {
    Uploaded = 1,
    Modified = 2,
    Deleted = 3,
  }

  export enum DocumentTemplateUploadTypes {
    UploadHeader = 'UploadHeader',
    UploadLogo = 'UploadLogo',
    UploadInsuredIcon = 'UploadInsuredIcon',
    UploadNotInsuredIcon = 'UploadNotInsuredIcon',
    UploadLimitsIcon = 'UploadLimitsIcon',
    UploadAimedAtWhoIcon = 'UploadAimedAtWhoIcon',
    UploadCostsIcon = 'UploadCostsIcon',
  }
  export enum ProductSimplificationStructureElementType {
    Chapter = 1,
    Section = 2,
    Paragraph = 3,
  }

  export enum DocumentPreviewTypes {
    Text = 'Text',
    Figure = 'Figure',
    Paragraph = 'Paragraph',
    SectionHeading = 'sectionHeading',
    Table = 'Table',
    Header = 'Header',
  }

  export enum Profiles {
    Admin = 'Admin',
    Standard = 'Standard',
  }
}
